export const DANGER_STYLE = "danger";
export const SECONDARY_STYLE = "secondary";

export const LARGE_STYLE = "large";
export const MEDIUM_STYLE = "medium";
export const SMALL_STYLE = "small";

export const SUCCESS = "Success";
export const FAIL = "Fail";
